<template>
  <v-container fluid>
    <v-card>
      <div class="pr-md-4 border-bottom d-flex align-items-center justify-content-between">
        <PageTitle
          title-class="h5"
          text="Relatórios"
        />
      </div>
      <v-tabs
        v-model="tab"
        align-with-title
      >
        <v-tab>
          Visão geral
        </v-tab>
        <v-tab>
          Desempenho por módulo
        </v-tab>
        <v-tab>
          Desempenho por questão
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab">
        <v-tab-item>
          <v-container
            class="bg-gray-100"
            fluid
          >
            <v-row>
              <v-col>
                <v-card>
                  <PageTitle text="Estudo do ciclo">
                    <template #suffixTitle>
                      <BtnInfo tooltip-text="Confira aqui seus resultados e se você concluiu os módulos até a meta de conclusão de cada um" />
                    </template>
                  </PageTitle>
                  <CycleContentGoalProgress />
                </v-card>
              </v-col>
            </v-row>


            <v-row>
              <v-col md="5">
                <v-card>
                  <PageTitle text="Meu Desempenho">
                    <template #suffixTitle>
                      <BtnInfo :tooltip-text="STUDENT_PERFORMANCE_METRICS_INFO" />
                    </template>
                  </PageTitle>
                  <CardsPerformanceSession v-if="finishedCycles.filter(c=>c.order>0).length>0" />
                  <v-card-text v-else>
                    <p class="text-body-1 text-center mt-6">
                      Você ainda não tem nenhum ciclo encerrado.
                      <br> Seu desempenho será exibido aqui quando o ciclo finalizar.
                    </p>
                  </v-card-text>
                </v-card>
              </v-col>

              <v-col md="4">
                <v-card>
                  <PageTitle text="Por Disciplina">
                    <template #suffixTitle>
                      <BtnInfo :tooltip-text="STUDENT_SUBJECT_PERFORMANCE_METRICS_INFO" />
                    </template>
                  </PageTitle>
                  <PerformancePerSubject />
                </v-card>
              </v-col>
              <v-col md="3">
                <v-card>
                  <PageTitle text="Por módulo">
                    <template #suffixTitle>
                      <BtnInfo :tooltip-text="STUDENT_MODULE_PERFORMANCE_METRICS_INFO" />
                    </template>
                  </PageTitle>
                  <v-card-text class="px-0">
                    <PerformancePerModule />
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </v-tab-item>
        <v-tab-item>
          <CyclesPerModule />
        </v-tab-item>
        <v-tab-item key="Desempenho por questão">
          <PerformancePerQuestion />
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </v-container>
</template>
<script>
import CardsPerformanceSession from "./components/CardsPerformanceSession";
import PerformancePerModule from "./components/PerformancePerModule";
import PerformancePerQuestion from "./components/PerformancePerQuestion";
import CycleContentGoalProgress from "./components/CycleContentGoalProgress";
import PerformancePerSubject from "./components/PerformancePerSubject";
import CyclesPerModule from "./components/CyclesPerModule"
import PageTitle from "@/common/components/PageTitle";
import BtnInfo from "@/common/components/BtnInfo";
import {STUDENT_WEEKLY_METRICS_INFO, STUDENT_PERFORMANCE_METRICS_INFO,STUDENT_MODULE_PERFORMANCE_METRICS_INFO, STUDENT_SUBJECT_PERFORMANCE_METRICS_INFO } from "@/constants/messages_info.js";
import HasTabs from "@/common/mixins/HasTabs"
import { mapActions, mapGetters } from 'vuex';
export default {
  components: {
    BtnInfo,
    CardsPerformanceSession,
    PerformancePerModule,
    CycleContentGoalProgress,
    PerformancePerSubject,
    CyclesPerModule,
    PageTitle,
    PerformancePerQuestion,
  },
  mixins:[HasTabs],
  data() {
    return {
      STUDENT_WEEKLY_METRICS_INFO,
      STUDENT_PERFORMANCE_METRICS_INFO,
      STUDENT_MODULE_PERFORMANCE_METRICS_INFO,
      STUDENT_SUBJECT_PERFORMANCE_METRICS_INFO
    }
  },
  computed:{
    ...mapGetters(['selectedYear','finishedCycles'])
  },
  mounted(){
    this.getCycles({filters:'&with-metrics', set_current_cycle: true})
  },
  methods:{
    ...mapActions(['getCycles']),
  },
}
</script>
